// extracted by mini-css-extract-plugin
module.exports = {"examSectionName":"style-module__examSectionName___1a3VY","mobileButton":"style-module__mobileButton___3W9-F"};